export const YES_NO_QUESTION = "yes_no";
export const ZERO_TO_FOUR_QUESTION = "zero_to_four";
